"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _history = require("../../utils/history");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var NotFoundError = function NotFoundError() {
  return _react.default.createElement(_UIErrorMessage.default, {
    type: "notFound",
    title: (0, _unescapedText.default)('appMarketplace.error.notFound.title')
  }, _react.default.createElement(_UIButton.default, {
    use: "tertiary",
    className: "m-top-4",
    onClick: function onClick() {
      return (0, _history.push)('/');
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.error.notFound.button"
  })));
};

var _default = NotFoundError;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/error/NotFoundError.js
// module id = 324
// module chunks = 209 210 211 212